/* Doodle Duo — theme.js
   Small, dependency-free enhancements. Everything works without JS
   (forms post normally); this layer just makes it smoother. */

(function () {
  'use strict';

  var body = document.body;
  var CART_ADD_URL = body.dataset.cartAddUrl || '/cart/add';
  var CART_URL = body.dataset.cartUrl || '/cart';
  var MONEY_FORMAT = body.dataset.moneyFormat || '${{amount}}';

  /* ---- Money formatting (matches the store's money format) ---- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var value = '';
    switch ((format.match(placeholderRegex) || [])[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  /* ---- Mobile menu toggle ---- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuDrawer = document.querySelector('[data-menu-drawer]');
  if (menuToggle && menuDrawer) {
    menuToggle.addEventListener('click', function () {
      var open = menuDrawer.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menuToggle.querySelector('[data-icon-menu]').hidden = open;
      menuToggle.querySelector('[data-icon-close]').hidden = !open;
    });
  }

  /* ---- Cart count bubble ---- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function refreshCartCount() {
    fetch(CART_URL + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () {});
  }

  /* ---- Quick add (product cards) + product form AJAX add ---- */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-ajax-cart]');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    fetch(CART_ADD_URL + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (e) { throw e; });
        return response.json();
      })
      .then(function () {
        refreshCartCount();
        if (button) {
          button.textContent = 'Added! ✓';
          setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1800);
        }
      })
      .catch(function (error) {
        if (button) {
          button.textContent = (error && error.description) ? 'Sold out' : 'Try again';
          setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 2500);
        }
      });
  });

  /* ---- Product page: variant picker ---- */
  var productForm = document.querySelector('[data-product-form]');
  var variantJson = document.querySelector('[data-variant-json]');
  if (productForm && variantJson) {
    var variants = JSON.parse(variantJson.textContent);
    var idInput = productForm.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var buyButton = productForm.querySelector('[data-buy-button]');

    function selectedOptions() {
      var options = [];
      productForm.querySelectorAll('[data-option-index]').forEach(function (group) {
        var index = parseInt(group.dataset.optionIndex, 10);
        var checked = group.querySelector('input[type="radio"]:checked');
        var select = group.querySelector('select');
        options[index] = checked ? checked.value : (select ? select.value : null);
      });
      return options;
    }

    function onOptionChange() {
      var options = selectedOptions();
      var match = variants.find(function (variant) {
        return variant.options.every(function (value, i) { return value === options[i]; });
      });

      if (!match) {
        if (buyButton) { buyButton.disabled = true; buyButton.textContent = 'Unavailable'; }
        return;
      }

      idInput.value = match.id;
      if (priceEl) {
        var priceHtml = formatMoney(match.price, MONEY_FORMAT);
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceHtml = '<span class="price__sale">' + priceHtml + '</span> ' +
            '<s class="price__compare">' + formatMoney(match.compare_at_price, MONEY_FORMAT) + '</s>';
        }
        priceEl.innerHTML = priceHtml;
      }
      if (buyButton) {
        buyButton.disabled = !match.available;
        buyButton.textContent = match.available ? buyButton.dataset.addLabel : 'Sold out';
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());

      var media = document.querySelector('[data-media-id="' + (match.featured_media ? match.featured_media.id : '') + '"]');
      if (media) activateMedia(media.dataset.mediaId);
    }

    productForm.addEventListener('change', function (event) {
      if (event.target.closest('[data-option-index]')) onOptionChange();
    });    if (new URLSearchParams(window.location.search).has('variant')) onOptionChange();
  }

  /* ---- Product page: gallery ---- */
  function activateMedia(mediaId) {
    document.querySelectorAll('[data-media-id]').forEach(function (el) {
      el.classList.toggle('is-active', el.dataset.mediaId === mediaId);
    });
    document.querySelectorAll('[data-thumb-id]').forEach(function (el) {
      var active = el.dataset.thumbId === mediaId;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-thumb-id]');
    if (thumb) activateMedia(thumb.dataset.thumbId);
  });

  /* ---- Collection filters: submit on change ---- */
  var facetsForm = document.querySelector('[data-facets-form]');
  if (facetsForm) {
    facetsForm.addEventListener('change', function (event) {
      if (event.target.type === 'number') return; // wait for explicit apply on price
      facetsForm.submit();
    });
  }

  /* ---- Cart page: auto-submit quantity changes ---- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('change', function (event) {
      if (event.target.matches('input[name="updates[]"]')) cartForm.submit();
    });
  }

  /* ---- Related products (Shopify recommendations) ---- */
  var related = document.querySelector('[data-related-products]');
  if (related) {
    fetch(related.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var inner = html.querySelector('[data-related-products]');
        if (inner && inner.innerHTML.trim().length) {
          related.innerHTML = inner.innerHTML;
        } else {
          var section = related.closest('.shopify-section');
          if (section) section.style.display = 'none';
        }
      })
      .catch(function () {});
  }
})();
/* Close open nav dropdowns when clicking elsewhere or pressing Escape */
document.addEventListener('click', function (event) {
  document.querySelectorAll('details.nav-dropdown[open]').forEach(function (dropdown) {
    if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
  });
});
document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    document.querySelectorAll('details.nav-dropdown[open]').forEach(function (dropdown) {
      dropdown.removeAttribute('open');
    });
  }
});